import { defineComponent } from '@vue/composition-api';

var script = defineComponent({
    name: 'SdsBadge',
    props: {
        background: {
            type: String,
            required: false,
            default: 'elevation',
        },
        variant: {
            type: String,
            required: false,
            default: 'primary',
        },
        styling: {
            type: String,
            required: false,
            default: 'brand',
        },
        size: {
            type: String,
            required: false,
            default: 'lg',
        },
        shape: {
            type: String,
            required: false,
            default: 'pill',
        },
        isSingleCharacter: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
});

export default script;
